import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    entities: null,
    favoriteSegmentsInGroup: {}
};

const requestSegments = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveSegments = (state, action) => {
    return {
        ...state,
        isFetching: false,
        entities: action.data || [],
        lastUpdated: action.receivedAt
    };
};

const receiveSegmentsError = (state) => {
    return {
        ...state,
        isFetching: false,
        entities: []
    };
};

const requestFavoriteGroupActivities = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveFavoriteGroupActivities = (state, action) => {
    /*set key of favorite segment for group as groupPk to prevent duplicates, to easily filter and to easily overwrite on post*/
    return {
        ...state,
        favoriteSegmentsInGroup: {
            ...state.favoriteSegmentsInGroup,
            [action.response.groupPk]: action.response
        },
        isFetching: false
    };
};

const resetFavoriteGroupActivities = (state) => {
    return {
        ...state,
        favoriteSegmentsInGroup: INITIAL_STATE.favoriteSegmentsInGroup,
        isFetching: false
    };
};

const addRemoveFromFavorites = (state, action) => {
    const newSegments = getSegmentListWithUpdatedFavorites(state, action.segmentpk, action.favorite);
    return {
        ...state,
        entities: newSegments
    };
};

const getSegmentListWithUpdatedFavorites = (state, segmentPk, favorite) => {
    return state.entities.map(function(localSegment) {
        if (localSegment.segmentPk === segmentPk) {
            localSegment.favorite = favorite;
        }
        return localSegment;
    });
};

const deletedSegment = (state, action) => {
    const segments = getSegmentListWithDeletedSegment(state, action);
    return {
        ...state,
        entities: segments
    };
};

const getSegmentListWithDeletedSegment = (state, actionData) => {
    return state.entities.filter(function(localSegment) {
        return localSegment.uuid !== actionData.segmentUuid;
    });
};

const handlers = {
    [types.REQUEST_SEGMENTS]: requestSegments,
    [types.RECEIVE_SEGMENTS]: receiveSegments,
    [types.RECEIVE_SEGMENTS_ERROR]: receiveSegmentsError,
    [types.REQUEST_FAVORITE_GROUP_SEGMENT]: requestFavoriteGroupActivities,
    [types.RECEIVE_FAVORITE_GROUP_SEGMENT]: receiveFavoriteGroupActivities,
    [types.RESET_FAVORITE_GROUP_SEGMENT]: resetFavoriteGroupActivities,
    [types.TOGGLE_FAVORITE_SEGMENT]: addRemoveFromFavorites,
    [types.DELETED_SEGMENT]: deletedSegment
};

export const getSegments = (state) => state.segments.entities;
export const getFavoriteSegmentsInGroup = (state) => state.segments.favoriteSegmentsInGroup;
export const isFetchingSegments = (state) => state.segments.isFetching;

export default function segments(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
